import styled from '@emotion/styled'

export default styled.div((props) => {
  const {
    theme: { pillBackgroundColor, pillColor },
  } = props

  return `
    margin: 0 auto;
    width: 60px;
    height: 15px;
    background-color: ${pillBackgroundColor};
    font-size: 10px;
    color: ${pillColor};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  `
})
